"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPTUCREATE = exports.faker_iptu = exports.create_iptu_sp = exports.create_iptu_ctba = void 0;
var utils_1 = require("../utils");
var mask_1 = require("./mask");
function create_iptu_ctba(number) {
    number = utils_1.getAllDigits(number);
    var a1 = parseInt(number.slice(10));
    var a2 = parseInt(number.slice(9, 10));
    var a3 = parseInt(number.slice(8, 9));
    var a4 = parseInt(number.slice(7, 8));
    var a5 = parseInt(number.slice(6, 7));
    var a6 = parseInt(number.slice(5, 6));
    var a7 = parseInt(number.slice(4, 5));
    var a8 = parseInt(number.slice(3, 4));
    var a9 = parseInt(number.slice(2, 3));
    var a10 = parseInt(number.slice(1, 2));
    var a11 = parseInt(number.slice(0, 1));
    var iptuctbaDV = 10 - ((a1 * 2 + a2 * 3 + a3 * 4 + a4 * 7 + a5 * 8 + a6 * 9 + a7 * 2 + a8 * 3 + a9 * 4 + a10 * 7 + a11 * 8) % 10);
    if (iptuctbaDV == 10) {
        iptuctbaDV = 0;
    }
    return iptuctbaDV;
}
exports.create_iptu_ctba = create_iptu_ctba;
function create_iptu_sp(number) {
    var a1 = parseInt(number.slice(9));
    var a2 = parseInt(number.slice(8, 9));
    var a3 = parseInt(number.slice(7, 8));
    var a4 = parseInt(number.slice(6, 7));
    var a5 = parseInt(number.slice(5, 6));
    var a6 = parseInt(number.slice(4, 5));
    var a7 = parseInt(number.slice(3, 4));
    var a8 = parseInt(number.slice(2, 3));
    var a9 = parseInt(number.slice(1, 2));
    var a10 = parseInt(number.slice(0, 1));
    var iptuspDV = (a1 * 9 + a2 * 8 + a3 * 7 + a4 * 6 + a5 * 5 + a6 * 4 + a7 * 3 + a8 * 2 + a9 + a10 * 10) % 11;
    if (iptuspDV == 10) {
        iptuspDV = 1;
    }
    return iptuspDV;
}
exports.create_iptu_sp = create_iptu_sp;
exports.faker_iptu = function (estado, cidade) {
    if (!mask_1.IPTUMASKS[estado] || !mask_1.IPTUMASKS[estado][cidade]) {
        return;
    }
    var iptu = utils_1.makeGenericFaker(mask_1.IPTUMASKS[estado][cidade])();
    if (exports.IPTUCREATE[estado] && exports.IPTUCREATE[estado][cidade]) {
        var dv = exports.IPTUCREATE[estado][cidade](iptu);
        var values = iptu.split('');
        values[values.length - 1] = dv;
        iptu = values.join('');
    }
    return iptu;
};
exports.IPTUCREATE = {
    'sao-paulo': {
        'sao-paulo': create_iptu_sp,
    },
    'parana': {
        'curitiba': create_iptu_ctba
    }
};
//# sourceMappingURL=create.js.map